import PigletTransportApi from "@/api/pig-registration/piglet/PigletTransportApi";
export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch}, items) {
      try {
        const response = await PigletTransportApi.addOrUpdate(items);
        await dispatch('NOTIFY_MSG', 'pigRegistration.notification.savePigletTransport', {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchByWeekId({dispatch}, {weekId}) {
      try {
        const response = await PigletTransportApi.fetchByWeekId(weekId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchInstructions({dispatch}, {transporterId, transportDate, transporterIndex, driver}) {
      try {
        const response = await PigletTransportApi.fetchInstructions(transporterId, transportDate, transporterIndex, driver);
        return response.data;
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async createDeliveryNotes({dispatch}, form) {
      try {
        await PigletTransportApi.createDeliveryNotes(form);
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async move({dispatch}, {pigletTransportId, calendarWeekId}) {
      try {
        const response = await PigletTransportApi.move(pigletTransportId, calendarWeekId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async split({dispatch}, {pigletTransportId}) {
      try {
        const response = await PigletTransportApi.split(pigletTransportId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async remove({dispatch}, {pigletTransportId}) {
      try {
        const response = await PigletTransportApi.remove(pigletTransportId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
